/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';

export type DashboardPrintViewContextValue = {
  isPrintView: boolean;
};

export const DEFAULT_DASHBOARD_PRINT_VIEW_CONTEXT: DashboardPrintViewContextValue = {
  isPrintView: false,
};

export const DashboardPrintViewContext = React.createContext(DEFAULT_DASHBOARD_PRINT_VIEW_CONTEXT);
